import { useHasPermission } from '../../../hooks/useHasPermission'

function PermissionContainer({
	permissionCode,
	children
}: {
	permissionCode: string
	children: any
}) {
	const hasPermission = useHasPermission({ code: permissionCode })

	return hasPermission ? children : null
}

export default PermissionContainer
